const EMPTY_STATE_TEXT = 'Enter inputs to generate Hansen sketch.';
const EMPTY_STATE_WIDTH = 360;
const EMPTY_STATE_HEIGHT = 52;
const EMPTY_STATE_RADIUS = 10;

export default function HansenSketchEmptyState({ VW, VH, theme, textClassName }) {
  return (
    <g>
      <rect
        x={(VW - EMPTY_STATE_WIDTH) / 2}
        y={VH - 82}
        width={EMPTY_STATE_WIDTH}
        height={EMPTY_STATE_HEIGHT}
        rx={EMPTY_STATE_RADIUS}
        fill={theme === 'light' ? '#fff' : '#3d3d3d'}
        stroke="currentColor"
        strokeOpacity="0.65"
      />
      <text className={textClassName} x={VW / 2} y={VH - 50} textAnchor="middle" opacity="0.75">
        {EMPTY_STATE_TEXT}
      </text>
    </g>
  );
}
